import { FEATURES } from "@home-health-notify/domain";
import AppsIcon from "@mui/icons-material/Apps";
import CampaignIcon from "@mui/icons-material/Campaign";
import GroupsIcon from "@mui/icons-material/Groups";
import HomeIcon from "@mui/icons-material/Home";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import { ChatContext, OrganizationContext, useTranslation } from "hhn-commons";
import React, { useContext } from "react";
import { Link } from "react-router";
import { AddBroadcastGroup } from "../../addBroadcastGroup/AddBroadcastGroup";
import { AddInternalGroup } from "../../addInternalGroup/AddInternalGroup";
import { AddPatientGroup } from "../../addPatientGroup/AddPatientGroup";
import { RightDrawerContext } from "../../context/RightDrawerContext";
import { MODAL_ROUTES } from "../../routes";
import { PaperProp } from "../userMenu/UserMenu.style";

export const OrganizationMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { openDrawer, setContent } = useContext(RightDrawerContext);
  const { selectedOrgUser } = useContext(OrganizationContext);
  useContext(ChatContext);
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "organization" });

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openNewPatientGroup = () => {
    setContent(<AddPatientGroup mode="new" />);
    openDrawer();
  };

  const openNewInternalGroup = () => {
    setContent(<AddInternalGroup />);
    openDrawer();
  };

  const openNewBroadcastGroup = () => {
    setContent(<AddBroadcastGroup />);
    openDrawer();
  };

  const hasAnyOrgMenuItem =
    !!selectedOrgUser?.hasAccess(FEATURES.CREATE_INTERNAL_GROUP) ||
    !!selectedOrgUser?.hasAccess(FEATURES.CREATE_PATIENT_GROUP) ||
    !!selectedOrgUser?.hasAccess(FEATURES.CREATE_BROADCAST) ||
    !!selectedOrgUser?.hasAccess(FEATURES.VIEW_ORGANIZATION_MEDIA);

  if (!hasAnyOrgMenuItem) {
    return null;
  }

  return (
    <>
      <Tooltip title="Open organization menu" placement="right-end">
        <IconButton
          size="large"
          aria-label="Organization Menu"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          color="inherit"
        >
          <AppsIcon htmlColor="white" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="org-menu"
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: PaperProp,
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {selectedOrgUser?.hasAccess(FEATURES.CREATE_INTERNAL_GROUP) && (
          <MenuItem onClick={openNewInternalGroup}>
            <ListItemIcon>
              <GroupsIcon fontSize="small" />
            </ListItemIcon>
            {tNs("headerMenu.newInternalGroup")}
          </MenuItem>
        )}
        {selectedOrgUser?.hasAccess(FEATURES.CREATE_PATIENT_GROUP) && (
          <MenuItem onClick={openNewPatientGroup}>
            <ListItemIcon>
              <HomeIcon fontSize="small" />
            </ListItemIcon>
            {tNs("headerMenu.newPatientGroup")}
          </MenuItem>
        )}
        {selectedOrgUser?.hasAccess(FEATURES.CREATE_BROADCAST) && (
          <MenuItem onClick={openNewBroadcastGroup}>
            <ListItemIcon>
              <CampaignIcon fontSize="small" />
            </ListItemIcon>
            {tNs("headerMenu.newBroadcast")}
          </MenuItem>
        )}
        {selectedOrgUser?.hasAccess(FEATURES.VIEW_ORGANIZATION_MEDIA) && (
          <MenuItem
            component={Link}
            to={`?modal=${MODAL_ROUTES.ORGANIZATION_MEDIA}`}
          >
            <ListItemIcon>
              <PermMediaIcon fontSize="small" />
            </ListItemIcon>
            {tNs("headerMenu.organizationMedia")}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
